var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mbo-obs"},[_c('MbOverlayStage',[_c('MbOverlay',{attrs:{"scene":_vm.scene,"battle":_vm.battle,"post-battle":_vm.postBattle,"events":_vm.events,"series":_vm.series,"title":_vm.title,"casters":_vm.casters}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }